<template>
    <v-dialog v-model="dialog" persistent max-width="400px">
        <template v-slot:activator="{ on, attrs }">
            <v-btn v-on="on" v-bind="attrs" color="primary">
                버전등록
            </v-btn>
        </template>
        <v-card>
            <v-card-title>
                <span class="headline">버전등록</span>
            </v-card-title>
            <v-card-text>
                <v-stepper v-model="step">
                    <v-stepper-header>
                        <v-stepper-step :complete="step> 1" step="1">버전 파일 등록</v-stepper-step>
                        <v-divider></v-divider>
                        <v-stepper-step :complete="step> 2" step="2">테스트 사업자 지정</v-stepper-step>
                        <v-divider></v-divider>
                    </v-stepper-header>

                    <v-stepper-items>
                        <v-stepper-content step="1">
                            <monitoring-agent-file-upload-step1
                                    v-model=fileContext></monitoring-agent-file-upload-step1>
                        </v-stepper-content>

                        <v-stepper-content step="2">
                            <monitoring-agent-file-upload-step2
                                    v-model=rentalcompanyContext></monitoring-agent-file-upload-step2>
                        </v-stepper-content>
                    </v-stepper-items>
                </v-stepper>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="onClose">닫기</v-btn>
                <v-btn color="blue darken-1" text @click="onPrevStep">이전</v-btn>
                <v-btn color="blue darken-1" text @click="onNextStep">다음</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import MonitoringAgentFileUploadStep1 from "../version-deploy/MonitoringAgentFileUploadStep1";
    import MonitoringAgentFileUploadStep2 from "../version-deploy/MonitoringAgentFileUploadStep2";
    import {PATH} from "@/constants";

    export default {
        name: "AgentFileUploadButton",
        components: {MonitoringAgentFileUploadStep2, MonitoringAgentFileUploadStep1},
        data: function() {
            return {
                dialog: false,
                step: 1,
                version_data: {},
                filename: Array,
                fileContext: {
                    pageData: {
                        version: null,
                        type: null,
                        files: []
                    }
                },
                rentalcompanyContext: {
                    checkItems: [],
                }
            }
        },
        methods: {
            onPrevStep(){
                if(this.step == 2) {
                    this.step = 1;
                }
            },
            onNextStep(){
                if(this.step == 1) {
                    this.step = 2;
                }
                else if(this.step == 2) {
                    if(this.validate()){
                        this.setUploadedFileInfo();
                        this.onSubmit();
                    }
                }
                console.log(this.step)
            },
            validate(){
                if(this.fileContext.pageData.files.length == 0) {
                    alert(this.t("파일을 선택해주세요"));
                    return false;
                }
                if(this.fileContext.pageData.version == null) {
                    alert(this.t("Agent 버전을 입력해주세요"));
                    return false;
                }
                if(this.fileContext.pageData.type == null) {
                    alert(this.t("Agent 타입을 입력해주세요"));
                    return false;
                }
                if(this.rentalcompanyContext.checkItems.length == 0) {
                    alert(this.t("테스트 임대업체를 선택해주세요"));
                    return false;
                }
                return true;
            },
            setUploadedFileInfo(){
                this.version_data.type = this.fileContext.pageData.type;
                this.version_data.version = this.fileContext.pageData.version;
                this.version_data.files = this.fileContext.pageData.files;
                this.version_data.rentalcompanyIds = this.rentalcompanyContext.checkItems;
                this.filename = this.fileContext.pageData.files.map(function (obj) {
                    return obj.file
                });
            },
            async onSubmit() {
                if (!confirm(this.t("Agent 버전을 추가 하시겠습니까?"))) {
                    return;
                }
                const res = await this
                                    .$request(PATH.MONITORING.AGENT_FILE_UPLOAD)
                                    .post()
                                    .appendObject("context", this.version_data)
                                    .setFiles("files", this.filename)
                                    .multipart()
                                    .catch()
                                    .enqueue()
                                    .then(res => {
                                        alert(this.t("버전을 추가했습니다."));
                                        this.onClose();
                                    })
                                    .catch(error => {
                                        alert(this.t("에러가 발생했습니다."))
                                        console.log("Error:" + JSON.stringify(error))
                                        this.onClose();
                                    })
            },

            onClose(){
                this.dialog = false;
                this.step = 1;
                this.fileContext = null;
                this.rentalcompanyContext = null;
            }
        }
    }
</script>

<style scoped>

</style>